exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reject-repay-dialog{width:80.8vw;border-radius:2.13333vw;padding:8vw 6.4vw 8.53333vw;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden\n}\n.reject-repay-dialog .container p{font-family:PingFang SC;font-size:4vw;font-weight:normal;line-height:5.86667vw;letter-spacing:0px;color:#49596C\n}\n.reject-repay-dialog .container p.bold{font-size:4.26667vw;font-weight:600;line-height:6.4vw;color:#002A3C\n}\n.reject-repay-dialog .container p:not(:last-child){margin-bottom:4.26667vw\n}\n", ""]);

// exports
